import {Box, IconButton, Tooltip} from "@mui/material";
import {ContentCopy, Check} from "@mui/icons-material";
import {useMemo, useState} from "react";
import {highlightTokens} from "../Utils/syntaxHighlight";

// Palette façon éditeur de code (One Dark), fixe quel que soit le thème de la page —
// un bloc de code doit rester lisible/reconnaissable, pas suivre le clair/sombre du site.
const TOKEN_COLORS = {
    keyword: '#c678dd',
    phpTag: '#c678dd',
    func: '#61afef',
    constant: '#d19a66',
    variable: '#e06c75',
    flag: '#56b6c2',
    string: '#98c379',
    jsonKey: '#e06c75',
    number: '#d19a66',
    bool: '#d19a66',
    plain: '#abb2bf',
};

function CodeBlock({children, copyValue, language = 'text', sx}) {
    const [copied, setCopied] = useState(false);
    const code = typeof children === 'string' ? children : String(children);
    const tokens = useMemo(() => highlightTokens(code, language), [code, language]);

    const handleCopy = () => {
        navigator.clipboard.writeText(copyValue ?? code).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <Box sx={{position: 'relative', ...sx}}>
            <Box component="pre" sx={{
                fontFamily: 'monospace', fontSize: 13, bgcolor: '#282c34', color: TOKEN_COLORS.plain,
                p: 2, pr: 6, borderRadius: 1, overflowX: 'auto', m: 0,
                whiteSpace: 'pre-wrap', wordBreak: 'break-all', textAlign: 'left',
            }}>
                {tokens.map((token, i) => (
                    <Box key={i} component="span" sx={{color: TOKEN_COLORS[token.type] || TOKEN_COLORS.plain}}>
                        {token.text}
                    </Box>
                ))}
            </Box>
            <Tooltip title={copied ? 'Copié !' : 'Copier'}>
                <IconButton size="small" onClick={handleCopy} sx={{
                    position: 'absolute', top: 4, right: 4, color: '#abb2bf',
                    '&:hover': {bgcolor: 'rgba(255,255,255,0.08)'},
                }}>
                    {copied ? <Check fontSize="small" sx={{color: '#98c379'}}/> : <ContentCopy fontSize="small"/>}
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export default CodeBlock;
